import { PropsWithChildren } from 'react';
import { ExcludeOurTypography } from '../Typography';
import { DottedTextB2 } from './DottedText.style';

export function DottedText({ children, ...props }: PropsWithChildren<ExcludeOurTypography>) {
  return <DottedTextB2 {...props}>{children}</DottedTextB2>;
}
